import Vue from 'vue'
import router from '@/router'
import store from '@/store/'
import { ACCESS_TOKEN, USER_ROLE } from "@/store/mutation-types";
import HomeLayout from './layouts/HomeLayout'
import courseLayout from './layouts/courseLayout'
import examinationLayout from './layouts/examinationLayout'

const whiteList = ['/user/login', '/home'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  console.log(Vue.ls.get(ACCESS_TOKEN));
  if (Vue.ls.get(ACCESS_TOKEN)) {
    next()
  } else {
    if (whiteList.indexOf(to.path) == -1) {
      next()
      // next({ path: '/user/login', query: { redirect: to.fullPath, role: Vue.ls.get(USER_ROLE) } })
    } else {
      next()
    }
  }
})

let tenantConfig = store.getters.tenantInfo

/**
 * 基础路由
 * @type { *[] }
 */
const RouterMap = [
  {
    path: '/',
    component: HomeLayout,
    redirect: tenantConfig && tenantConfig.home || '/index',
    hidden: true,
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import(/* webpackChunkName: "School" */ './views/index'),
        meta:{title:'首页',index:1,}
      }, {
        path: '/more',
        name: 'more',
        component: () => import(/* webpackChunkName: "School" */ './views/more'),
        meta:{title:'更多',index:2}
      },{
        path: '/mine',
        name: 'mine',
        component: () => import(/* webpackChunkName: "School" */ './views/mine'),
        meta:{title:'我的',index:3}
      },{
        path: '/courseChoose',
        name: 'courseChoose',
        component: () => import(/* webpackChunkName: "School" */ './views/course/courseChoose'),
        meta:{title:'课程选择'}
      }
    ]
  },
  {
    path: '/examine',
    component:()=>import(/* webpackChunkName: "School" */ '@/components/exam/Examine')
  },
  {
    path: '/login',
    name:'login',
    component:()=>import(/* webpackChunkName: "School" */ './views/Login')
  },
  {
    path:'/course',
    component: courseLayout,
    redirect:'/course/courseChoose',
    children:[
      {
        path:'courseChoose',
        name:'courseChoose',
        component: () => import(/* webpackChunkName: "School" */ './views/course/courseChoose'),
        meta:{title:'考试管理',header:true}
      }, {
        path:'operate',
        name:'operate',
        component: () => import(/* webpackChunkName: "School" */ './views/course/operate'),
        meta:{title:'练习选择',header:false}
      }, {
        path:'examEntrance',
        name:'examEntrance',
        component: () => import(/* webpackChunkName: "School" */ './views/course/examEntrance'),
        meta:{title:'在线考试',header:true}
      },{
        path:'psychology',
        name:'psychology',
        component: () => import(/* webpackChunkName: "School" */ './views/examination/psychology'),
        meta:{title:'心理健康'}
      },{
        path:'Questionnaire',
        name:'Questionnaire',
        component: () => import(/* webpackChunkName: "School" */ './views/examination/Questionnaire'),
        meta:{title:'问卷调查健康'}
      },{
        path:'chapter',
        name:'chapter',
        component: () => import(/* webpackChunkName: "School" */ './views/examination/chapter'),
        meta:{title:'章节'}
      },{
        path:'ExamHistory',
        name:'ExamHistory',
        component: () => import(/* webpackChunkName: "School" */ './views/examination/ExamHistory'),
        meta:{title:'考试记录'}
      },{
        path:'integralList',
        name:'integralList',
        component: () => import(/* webpackChunkName: "School" */ './views/examination/integralList'),
        meta:{title:'考试记录'}
      },{
        path:'ErrorWorkbook',
        name:'ErrorWorkbook',
        component: () => import(/* webpackChunkName: "School" */ './views/examination/ErrorWorkbook'),
        meta:{title:'我的错题'}
      },{
        path:'videoStudy',
        name:'videoStudy',
        component: () => import(/* webpackChunkName: "School" */ './views/examination/videoStudy'),
        meta:{title:'视频学习'}
      }, {
        path: 'ExamHistoryDetail',
        name: 'ExamHistoryDetail',
        component: () => import(/* webpackChunkName: "School" */ './views/examination/ExamHistoryDetail'),
        meta:{title:'历史考试'}
      },{
        path:'practiceWorkbook',
        name:'practiceWorkbook',
        component: () => import(/* webpackChunkName: "School" */ './views/examination/practiceWorkbook'),
        meta:{title:'练习'}
      },{
        path:'consult',
        name:'consult',
        component: () => import(/* webpackChunkName: "School" */ './views/examination/consult'),
        meta:{title:'咨询预约'}
      },{
        path:'workBookList',
        name:'workBookList',
        component: () => import(/* webpackChunkName: "School" */ './views/course/workBookList'),
        meta:{title:'作业列表'}
      },{
        path:'noteList',
        name:'noteList',
        component: () => import(/* webpackChunkName: "School" */ './views/course/noteList'),
        meta:{title:'我的笔记'}
      },
    ]
  },
  //examinationLayout
  {
    path:'/examination',
    component: examinationLayout,
    redirect:'/examination/index',
    children:[
      {
        path:'index',
        name:'index',
        component: () => import(/* webpackChunkName: "School" */ './views/examination/index'),
        meta:{title:'考试管理'}
      }, {
        path:'Workbook',
        name:'Workbook',
        component: () => import(/* webpackChunkName: "School" */ './views/examination/Workbook'),
        meta:{title:'答题'}
      },
    ]
  },
]
export default RouterMap